import { lazy } from "react"
import { OysterRouter } from "~/router/type"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"

const CustomPricePage = lazy(() => import("../pages/CustomPricePage/CustomPricePage"))

export const staffMonetizationRoutes: OysterRouter = {
  "fullscreen-shell.center-align.alt-background": [
    {
      path: "/admin/companies/:companyStrongId/custom-price/new",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <CustomPricePage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
  ],
}
